import { LeadsIFrame } from "components/organisms/LeadsIFrame";

const CreateCustomer = () => {
  return <LeadsIFrame page="create" />;
};

export { CreateCustomer };
